import { ArrowUp } from "lucide-react";
import useScrollProgress from "@/hooks/useScrollProgress";

/**
 * Floating return-to-top control, shown only once the reader has passed a full
 * viewport. Icon-only, so it carries an explicit aria-label.
 */
export default function BackToTop() {
  const { isScrolled, isScrollable } = useScrollProgress();

  if (!isScrollable || !isScrolled) return null;

  const toTop = () => {
    // Smooth-scrolling several thousand pixels past 200 job cards is a
    // vestibular trigger; honour the OS-level preference.
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  };

  // bottom-36 clears FeedbackWidget, which is fixed at bottom-20 on every
  // signed-in page; at bottom-6 the iOS safe-area inset lifted this button into
  // the widget’s band and the two overlapped.
  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Back to top"
      title="Back to top"
      data-testid="back-to-top"
      className="fixed right-6 bottom-36 z-40 w-10 h-10 grid place-items-center rounded-sm
                 border border-sand bg-white/90 backdrop-blur text-stone-700 shadow-sm
                 transition-colors hover:bg-night-lift hover:text-white hover:border-night-lift
                 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-night-lift
                 [margin-bottom:env(safe-area-inset-bottom)]"
    >
      <ArrowUp className="w-4 h-4" />
    </button>
  );
}
